import "./Services.css";

function Services() {
  return (
    <section id="services" className="services">
      <h2>Our Services</h2>
      <img src="https://tse3.mm.bing.net/th/id/OIP.O9h8rCLVoQcsiBW1R6mZJgHaE8?w=1200&h=800&rs=1&pid=ImgDetMain&o=7&rm=3" className="services-img"/>
      <p className="services-subtitle">
        End-to-end renewable energy solutions designed for homes, businesses, and industries.
      </p>

      <div className="services-grid">
        <div className="service-card">
          <h3>Solar System Installation</h3>
          <p>
            Complete rooftop and ground-mounted solar installations with high-quality panels
            and professional setup.
          </p>
        </div>

        <div className="service-card">
          <h3>Energy Consultation</h3>
          <p>
            Expert consultation to analyze energy requirements and recommend cost-effective,
            sustainable solutions.
          </p>
        </div>

        <div className="service-card">
          <h3>Battery & Inverter Solutions</h3>
          <p>
            Reliable battery storage and inverter systems to ensure uninterrupted power supply.
          </p>
        </div>

        <div className="service-card">
          <h3>Maintenance & Support</h3>
          <p>
            Ongoing maintenance, monitoring, and technical support to maximize system performance.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Services;
